import { DEV } from "solid-js"
import { freeze } from "../core/util/Object"

const oneAndNegOne = [1, -1]

if (DEV) {
  freeze(oneAndNegOne)
}

export default oneAndNegOne